export default __webpack_public_path__ + "./images/eh.97d614a2.png";